'use strict';

import { CotalkerApi } from './api'
import { COTType } from './COTType'

export class FunctionsCode {
    api: CotalkerApi;
    functionMap: { [key: string]: { [key: string] : (auth: any, a: string, b: string, c: string) => Promise<COTType | null>} };

    constructor(baseURL: string | null) {
        this.api = new CotalkerApi(baseURL);
        this.functionMap = {
            accessrole: {},
            answers: {},
            bot: {
                name: async (auth: any, name): Promise<COTType> => this.api.getOneFromArray(await this.api.findBot({name}, auth)),
            },
            channel: {
                code: async (auth: any, nameCode): Promise<COTType> => this.api.getOneFromArray(await this.api.findChannels({nameCode}, auth)),
                id: async (auth: any, _id): Promise<COTType> => this.api.getOneFromArray(await this.api.findChannels({_id}, auth)),
            },
            company: {},
            group: {
                code: async (auth: any, nameCode): Promise<COTType> => this.api.getOneFromArray(await this.api.findGroups({nameCode}, auth)),
                id: async (auth: any, _id): Promise<COTType> => this.api.getOneFromArray(await this.api.findGroups({_id}, auth)),
            },
            message: {},
            property: {
                code: async (auth: any, propertyCode): Promise<COTType> => this.api.getOne(await this.api.getPropertyByCode(propertyCode, auth)),
                id: async (auth: any, _id): Promise<COTType> => this.api.getOne(await this.api.getProperty(_id, auth)),
            },
            propertytype: {},
            question: {},
            smstate: {
                propertygroupcode: async (auth: any, propertyCode, groupCode): Promise<COTType | null> => {
                    const group = this.api.getOneFromArray(await this.api.findGroups({nameCode: groupCode}, auth));
                    const property = this.api.getOne(await this.api.getPropertyByCode(propertyCode, auth));
                    if (!property) return null;
                    return this.api.findOneFromArray(await this.api.getSMStateForTaskGroup(group._id, auth), x => x.property._id === property._id);
                },
                propertycode: async (auth: any, propertyCode, taskGroup): Promise<COTType | null> => {
                    const property = this.api.getOne(await this.api.getPropertyByCode(propertyCode, auth));
                    if (!property) return null;
                    return this.api.findOneFromArray(await this.api.getSMStateForTaskGroup(taskGroup, auth), x => x.property._id === property._id);
                },
                property: async (auth: any, propertyId, taskGroup): Promise<COTType> => {
                    return this.api.findOneFromArray(await this.api.getSMStateForTaskGroup(taskGroup, auth), x => x.property._id === propertyId);
                },
            },
            smstatemachine: {},
            surveychat: {},
            survey: {
                code: async (auth: any, surveyCode): Promise<COTType> => this.api.getOneFromArray(await this.api.getSurveyByCode(surveyCode, auth)),
            },
            task: {
                channel: async (auth: any, channelId, taskGroup): Promise<COTType> => {
                    return this.api.getOneFromArray(await this.api.getTaskForChannel(taskGroup, channelId, auth));
                },
            },
            taskgroup: {
                group: async (auth: any, groupId): Promise<COTType> => this.api.getOne(await this.api.getTaskGroupByGroupId(groupId, auth)),
                // collectionName: async (auth: any, code1) => await this.apiPromise(done => this.api.getTaskGroupByCollectionName(code1, auth: any, this.api.getOneFromArray(done))),
            },
            user: {
                email: async (auth: any, email): Promise<COTType> => this.api.getOne(await this.api.getUserByEmail(email, auth)).data.users[0],
                id: async (auth: any, _id): Promise<COTType> => this.api.getOne(await this.api.getUser(_id, auth)),
            },
        };
    }

    // TODO Move auth to constructor
    async code(auth: any, modelIn: string, variantIn: string, code1: string, code2?: string, code3?: string) {
        // Convert USERS => user
        //         Companies => company
        //         Property_Types => propertytype
        const model = (modelIn || '')
            .toLocaleLowerCase()
            .replace(/[^a-z]/g, '')
            .replace(/ies$/, 'y')
            .replace(/s$/, '');

        const variant = (variantIn || '')
            .toLocaleLowerCase()
            .replace(/[^a-z]/, '');

        try {
            if (this.functionMap[model] && this.functionMap[model][variant]) {
                if (Array.isArray(code1)) {
                    return Promise.all(code1.map(async c1 => await this.functionMap[model][variant](auth, c1, code2 || '', code3 || '')))
                } else {
                    return await this.functionMap[model][variant](auth, code1, code2 || '', code3 || '')
                }
            }
        } catch (e) {
            console.log('ERROR', e);
        } // eslint-disable-line
        return this.throwError(model, variant, code1, code2, code3);
    }

    throwError(model: string, variant: string, code1: string, code2?: string, code3?: string) {
        console.log('$CODE ERROR', {data: {model, variant, code1, code2, code3}, code: 8499});
        throw new Error(`$CODE Unknown
model:${model || ''}
variant: ${variant || ''}
code1: ${code1 || ''}
code2: ${code2 || ''}
code3: ${code3 || ''}
`);
    };
}